<template>
    <nav class="side left compact fixed left-0 top-0 bottom-0 h-full z-30 pointer-events-none">
        <div id="mention" class="text-size8 font-bold font-anonymouse text-light_gray uppercase opacity-100 absolute">
            <span>AGRICULTURAL&nbsp;CHIC</span>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "SideMention"
    }
</script>

<style scoped>

</style>